import React from 'react';
import PropTypes from 'prop-types';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { PUBLICATION_STATUS } from 'constants/constants';
import {
  MarketsTooltip,
  MarketsTooltipRow,
  MarketsTooltipName,
  MarketsTooltipStatus,
  MarketsTooltipDot,
} from './styles';

const PublicationMarketsTooltip = ({ markets, marketsExist, theme, messages }) => {
  if (!marketsExist || !markets?.length) {
    return null;
  }

  const marketStatusLabel = (status) =>
    status === PUBLICATION_STATUS.PUBLISHED_LIVE
      ? intl.formatMessage(messages.publishedLive)
      : intl.formatMessage(messages.inReview);

  const marketStatusColor = (status) =>
    status === PUBLICATION_STATUS.PUBLISHED_LIVE
      ? theme['color.green']
      : theme['color.magenta'];

  return (
    <MarketsTooltip role="tooltip">
      {markets.map((m, i) => (
        <MarketsTooltipRow key={`${m.marketName}-${i}`}>
          <MarketsTooltipName title={m.marketName}>
            {m.marketName}
          </MarketsTooltipName>
          <MarketsTooltipStatus>
            <MarketsTooltipDot dotColor={marketStatusColor(m.marketStatus)} />
            <span>{marketStatusLabel(m.marketStatus)}</span>
          </MarketsTooltipStatus>
        </MarketsTooltipRow>
      ))}
    </MarketsTooltip>
  );
};

PublicationMarketsTooltip.propTypes = {
  markets: PropTypes.arrayOf(
    PropTypes.shape({
      marketName: PropTypes.string,
      marketStatus: PropTypes.string,
    }),
  ),
  marketsExist: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
};

export default PublicationMarketsTooltip;
